"use client"
import React, { useState, useEffect } from "react";

import Select from "react-select";

const SearchStyledSelect = props => {
  const customStyles = {
    control: base => ({
      ...base,
      borderRadius: "20px", // Rounded edges
      border: "1px solid #ccc", // Optional border styling
      paddingLeft: "2.5rem", // Make space for the icon
      boxShadow: "none",
      "&:hover": {
        borderColor: "#888" // Optional hover effect
      }
    }),
    input: base => ({
      ...base,
      marginLeft: "0.5rem"
    })
  };

  return (
    <div className="search-styled-select">
      {/* Magnifying Glass Icon */}
      <span
        className="material-icons"
        style={{
          position: "absolute",
          top: "50%",
          left: "2rem",
          transform: "translateY(-50%)",
          color: "#888",
          zIndex: 2
        }}
      >
        search
      </span>
      {/* React-Select */}
      <Select {...props} styles={customStyles} />
    </div>
  );
};
export default SearchStyledSelect;
